export const delay = async (ms: number, callback?: Function) => {
    await new Promise(resolve => setTimeout(resolve, ms));
    if (!!callback) return await callback();
}

export default delay;